import { render, staticRenderFns } from "./DmsUserProfile.vue?vue&type=template&id=21aa1e00"
import script from "./DmsUserProfile.vue?vue&type=script&lang=js"
export * from "./DmsUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports